import StepWrapper from "./StepWraper";
import RenderUsers from "./RenderUsers";

const AdminAssignment = () => {
  return (
    <StepWrapper
      title="🧑🏻‍💻 Admin assignment"
      description="Choose who will manage this organization and define their roles. The Owner can be changed later."
    >
      <RenderUsers />
    </StepWrapper>
  );
};

export default AdminAssignment;
